import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {Button, Card, Col, Row} from 'antd';
import {getBulkConsignment, recordBulkProductWaste} from './actions';
import PackageProductForm from "./PackageProductForm";
import DateTimeDisplay from "../common/DateTimeDisplay";
import MoneyDisplay from "../common/MoneyDisplay";
import {Link} from "react-router-dom";
import "./BulkConsignmentPage.css";
import NormalisedQuantityDisplay from "./NormalisedQuantityDisplay";
import ResponsiveTable from "../common/ResponsiveTable";
import {decodeParams} from "../utils/params";

class BulkConsignmentPage extends Component {
  state = {
    showRecordWasteModal: false,
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.bulkConsignmentId !== this.props.match.params.bulkConsignmentId) {
      this._load();
    }
  }

  _load = () => {
    const {bulkConsignmentId} = decodeParams(this.props.match.params);
    if (bulkConsignmentId) {
      this.props.getBulkConsignment({bulkConsignmentId});
    }
  };

  render() {
    const {loading, bulkConsignment, history} = this.props;
    const {bulkConsignmentId} = decodeParams(this.props.match.params);
    const packs = (bulkConsignment.packs || []).map(pack => ({...pack, bulkConsignmentId, page: this}));
    const titleStr = `Bulk Consignment of ${bulkConsignment.bulkProductName}`;
    const title = [
      <Button key="back-button" icon="arrow-left" onClick={history.goBack}/>,
      ' ',
      <span key='title-str' title={titleStr}>{titleStr}</span>,
    ];
    // const packagedPercent = (bulkConsignment.packagedGramWeight / bulkConsignment.gramWeight * 100).toFixed(0);
    const quantity = bulkConsignment.quantity || 0;
    const remainingQuantity = bulkConsignment.remainingQuantity || 0;
    const processedQuantity = quantity - remainingQuantity;
    const processedPercent = (processedQuantity / quantity * 100).toFixed();
    const remainingPercent = (remainingQuantity / quantity * 100).toFixed();
    const receivedExtra = <Link key='edit' to={`/bulk-consignment/update/${bulkConsignmentId}`}>Edit</Link>;
    return (
      <React.Fragment>
        <Card bordered={false} title={title} loading={loading}>
          <PackageProductForm
            dispensaryId={bulkConsignment && bulkConsignment.dispensaryId}
            bulkConsignment={bulkConsignment}
            productPackaged={this._load}
            isExpanded={processedQuantity < quantity}
          />
          <Row>
            <Col span={5}>
              <Card bordered={false} title='Summary'/>
            </Col>
            <Col span={7}>
              <Card bordered={false} title='Received' className='stat-card' loading={loading} extra={receivedExtra}>
                <p><NormalisedQuantityDisplay normalisedQuantity={quantity} unit={bulkConsignment.receivedUnit}/></p>
                <p><DateTimeDisplay dateTime={bulkConsignment.receivedAt}/></p>
                <p><MoneyDisplay amount={bulkConsignment.netCost}/></p>
              </Card>
            </Col>
            <Col span={6}>
              <Card bordered={false} title='Remaining' className='stat-card' loading={loading}>
                <p><NormalisedQuantityDisplay normalisedQuantity={remainingQuantity}
                                              unit={bulkConsignment.receivedUnit}/></p>
                <p>{remainingPercent} %</p>
              </Card>
            </Col>
            <Col span={6}>
              <Card bordered={false} title='Processed' className='stat-card' loading={loading}>
                <p><NormalisedQuantityDisplay normalisedQuantity={processedQuantity}
                                              unit={bulkConsignment.receivedUnit}/></p>
                <p>{processedPercent} %</p>
              </Card>
            </Col>
          </Row>
        </Card>
        <Card title="Product Packs">
          <ResponsiveTable
            loading={loading}
            columns={[
              {
                title: 'Packaged At',
                dataIndex: 'packagedAt',
                key: 'packagedAt',
                render: packagedAt => <DateTimeDisplay dateTime={packagedAt}/>,
              },
              {
                title: 'Product',
                dataIndex: 'productDisplay',
                key: 'productDisplay',
              },
              {
                title: 'Quantity',
                dataIndex: 'quantity',
                key: 'quantity'
              },
              {
                title: 'SKU',
                dataIndex: 'sku',
                key: 'sku',
              },
              {
                title: 'Net Cost Per Unit',
                dataIndex: 'netCostPerUnit',
                key: 'netCostPerUnit',
                render: netCostPerUnit => <MoneyDisplay amount={netCostPerUnit} decimals={5}/>,
              },
              {
                title: 'Bulk Qty',
                dataIndex: 'normalisedQuantity',
                key: 'normalisedQuantity',
                render: normQty => <NormalisedQuantityDisplay normalisedQuantity={normQty}
                                                              unit={bulkConsignment.receivedUnit}/>,
              },
              {
                title: 'Action',
                key: 'action',
                fixed: 'right',
                width: 130,
                render: (_, {productId, sku, packagedAt}) => {
                  const encodedProductId = encodeURIComponent(productId);
                  const encodedSku = encodeURIComponent(sku);
                  return (
                    <React.Fragment>
                      <Link to={`/product/correct-batch/${encodedProductId}/${encodedSku}/${encodeURIComponent(packagedAt)}`}>Correct</Link>
                      {' | '}
                      <Link to={`/product/label/${encodedProductId}/${encodedSku}`}>Label</Link>
                    </React.Fragment>
                  );
                },
              }
            ]}
            dataSource={packs}
            scroll={{x: 900}}
            rowKey="packagedAt"
          />
        </Card>
      </React.Fragment>
    );
  }
}

BulkConsignmentPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  bulkConsignment: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getBulkConsignment: PropTypes.func.isRequired,
  recordBulkProductWaste: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  bulkConsignment: state.bulkConsignment.bulkConsignment || {},
  loading: state.bulkConsignment.bulkConsignmentLoading,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getBulkConsignment,
  recordBulkProductWaste,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(BulkConsignmentPage);



// WEBPACK FOOTER //
// ./src/BulkConsignment/BulkConsignmentPage.js